export default "__VITE_ASSET__9207b74d__"